module.exports = __webpack_public_path__ + "media/2.1_comparative_superiority_piere_cf1.0bf6905d.wav";